module.exports = __webpack_public_path__ + "img/symbol_11.09e28cce.png";